const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUploadImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "image-plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M36 18.5V6.5",
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M42 12.5H30",
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_3",
    d: "M22 8.5L10.56 8.5C9.66392 8.5 9.21587 8.5 8.87362 8.67439C8.57256 8.82779 8.32779 9.07256 8.17439 9.37362C8 9.71587 8 10.1639 8 11.06L8 37.94C8 38.8361 8 39.2841 8.17439 39.6264C8.32779 39.9274 8.57256 40.1722 8.87362 40.3256C9.21587 40.5 9.66392 40.5 10.56 40.5H37.44C38.3361 40.5 38.7841 40.5 39.1264 40.3256C39.4274 40.1722 39.6722 39.9274 39.8256 39.6264C40 39.2841 40 38.8361 40 37.94V26.5",
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_4",
    d: "M36.5384 40.4035L22.4721 26.3493C21.838 25.7159 21.521 25.3991 21.1556 25.2806C20.8342 25.1763 20.4879 25.1765 20.1666 25.2811C19.8013 25.4001 19.4846 25.7171 18.8513 26.3513L8.15234 37.0641",
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_5",
    d: "M28.5195 32.38L31.9636 28.9604C32.6046 28.324 32.9251 28.0057 33.2933 27.8886C33.6171 27.7856 33.9654 27.7884 34.2875 27.8966C34.6538 28.0195 34.9691 28.3428 35.5999 28.9894L39.9999 33.5",
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadImg);
export default __webpack_public_path__ + "static/media/icon_upload_img.76bdc34e2d16cbdc53c90cbd452fda4d.svg";
export { ForwardRef as ReactComponent };